import { Typography, Box } from '@mui/material';

export default function ErrorMessage({ message }: { message: string }) {
    return (
      <Box width="100vw" height="100vh" display="grid" style={{ placeItems: 'center' }}>
        <Box>
          <Typography>{message}</Typography>
        </Box>
      </Box>
    );
  }
  